// painel.js — busca o Relatório de Propósito (painel do dono).
//
// A senha do painel NÃO fica no código: quem abre digita, e ela é guardada só na
// aba aberta (sessionStorage). Fechou o navegador, some. Assim a senha não vai
// junto no pacote do site, que é público.

import { API_ENDPOINT } from './api';

const CHAVE = 'jk::painel-token';

export const guardarSenha = (senha) => {
  try { sessionStorage.setItem(CHAVE, senha || ''); } catch (e) { /* modo anônimo */ }
};
export const lerSenha = () => {
  try { return sessionStorage.getItem(CHAVE) || ''; } catch (e) { return ''; }
};
export const esquecerSenha = () => {
  try { sessionStorage.removeItem(CHAVE); } catch (e) { /* nada */ }
};

// Devolve { ok, dados } ou { ok: false, motivo }.
export const buscarRelatorio = async (dias) => {
  const senha = lerSenha();
  if (!senha) return { ok: false, motivo: 'sem-senha' };
  try {
    // POST com a senha no CORPO: o site e a API ficam em endereços diferentes, e um
    // cabeçalho próprio exigiria mexer no CORS global da API (risco para o app todo).
    const r = await fetch(`${API_ENDPOINT}/relatorio-proposito`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: senha, dias: dias || 30 }),
    });
    if (r.status === 403) return { ok: false, motivo: 'senha-errada' };
    if (!r.ok) return { ok: false, motivo: 'servidor' };
    return { ok: true, dados: await r.json() };
  } catch (e) {
    return { ok: false, motivo: 'rede' };
  }
};
